define.alias("shared/components/shared/loading-cards", "calendar/components/shared/loading-cards");